(ns renolit-roofing-service.view.session.register-details
  (:require
   [dev.gethop.session.re-frame.cognito.token :as cognito.token]
   [malli.core :as m]
   [malli.transform :as mt]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [renolit-roofing-service.layout.form :as layout.form]
   [renolit-roofing-service.layout.form.error :as form.error]
   [renolit-roofing-service.layout.info-bar :as layout.info-bar]
   [renolit-roofing-service.layout.session :as layout.session]
   [renolit-roofing-service.localization :refer [t]]
   [renolit-roofing-service.navigation :as nav]
   [renolit-roofing-service.util :as util]
   [renolit-roofing-service.view :as view]
   [renolit-roofing-service.view.rae-home :as view.rae-home]
   [renolit-roofing-service.view.installer-home :as view.installer-home]))

(def ^:const view-context
  :register-details-view)

(def ^:const route-config
  {:name [:register-details]})

(def ^:const form-schema
  [:map
   [:first-name
    [:string]]
   [:last-name
    [:string]]
   [:company
    [:string]]
   [:nif
    [:string]]
   [:role
    [:keyword]]])

(rf/reg-event-fx
 ::register-details-success
 (fn [{:keys [db]} [_ user]]
   (let [route (if (= :installer (:role user))
                 (:name view.installer-home/route-config)
                 (:name view.rae-home/route-config))]
     {:db (assoc db :user user)
      :dispatch [::nav/push-state route]})))

(rf/reg-event-fx
 ::register-details-failure
 (fn [_ [_ reason]]
   {:dispatch-n [[::util/generic-error reason]
                 [::layout.info-bar/add-info-bar {:context view-context
                                                  :disappear-in-ms 5000
                                                  :type :error
                                                  :msg-transl-kw
                                                  (condp = reason
                                                    :unable-to-create-db-user
                                                    (t [:error-msg.unable-to-create-db-user])
                                                    (t [:error-msg.unknown]))}]]}))

(rf/reg-event-fx
 ::create-user
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [session]} [_ form-user]]
   (let [email (get-in session [:id-token :payload "email"])
         user (assoc form-user :email email)]
     {:http-xhrio {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
                   :method :post
                   :params user
                   :uri "/api/user"
                   :response-format (util/ajax-transit-response-format)
                   :format (util/ajax-transit-request-format)
                   :on-success [::register-details-success user]
                   :on-failure [::register-details-failure :unable-to-create-db-user]}})))

(defn- on-form-submit
  [state]
  (let [user (m/encode form-schema @state mt/strip-extra-keys-transformer)
        form-errors (form.error/check-errors form-schema user)]
    (cond
      form-errors
      (rf/dispatch [::form.error/register-errors view-context form-errors])

      :else
      (rf/dispatch [::create-user user]))))

(defn- main
  []
  (let [state (r/atom {})]
    (fn []
      [layout.session/layout
       [:<>
        [:div.session_main-description
         [:h3.session_main-description-title
          (t [:page.register/title])]
         [:span.session_main-description-subtitle
          (t [:page.register/subtitle])]]
        [:form.register_form
         {:on-submit
          (fn [e]
            (.preventDefault e)
            (on-form-submit state))}
         [layout.form/item
          {:context view-context
           :type :input
           :state state
           :path [:first-name]
           :mandatory? true
           :label-transl-kw :label.first-name
           :placeholder-transl-kw :placeholder.first-name
           :schema [:string]}]
         [layout.form/item
          {:context view-context
           :type :input
           :state state
           :path [:last-name]
           :mandatory? true
           :label-transl-kw :label.last-name
           :placeholder-transl-kw :placeholder.last-name
           :schema [:string]}]
         [layout.form/item
          {:context view-context
           :type :input
           :state state
           :path [:company]
           :mandatory? true
           :label-transl-kw :label.company
           :placeholder-transl-kw :placeholder.company
           :schema [:string]}]
         [layout.form/item
          {:context view-context
           :type :input
           :state state
           :path [:nif]
           :mandatory? true
           :label-transl-kw :label.nif
           :placeholder-transl-kw :placeholder.nif
           :schema [:string]}]
         [layout.form/item
          {:context view-context
           :type :advanced-select-with-fixed-choices
           :label-transl-kw :label.user-role
           :choice-placeholder-kw :placeholder.user-role
           :state state
           :path [:role]
           :mandatory? true
           :multi? false
           :search? false
           :choices [{:id :rae :name (t [:enum.user-role.rae])}
                     {:id :laboratory :name (t [:enum.user-role.laboratory])}
                     {:id :installer :name (t [:enum.user-role.installer])}]}]
         [:div.simple-form__action.register_form-actions
          [:button.btn.btn--primary
           {:type :submit}
           (t [:button.register])]]]]])))

(defmethod view/view-display (:name route-config)
  [_]
  [main])
